import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-fit" data-id="element-100">
      <div className="bg-white/80 backdrop-blur-md border border-[#E8E6E3] rounded-2xl p-2 pl-6 pr-2 flex items-center justify-between gap-6 shadow-[0_4px_20px_rgba(0,0,0,0.03)]" data-id="element-101">
        <Link to="/" className="flex items-center gap-2.5" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/wQE7QmjfHEAhLLQxvhgUnU/Andoe_Logo.png" alt="Andoe Logo" className="h-5 w-auto animate-logo-entrance" data-id="element-103" />
          <span className="text-[10px] font-semibold tracking-wider uppercase text-[#5C5C5C] border border-[#D0CEC9] rounded-full px-2 py-0.5 leading-none" data-id="element-104">
            Beta
          </span>
        </Link>

        {/* Hamburger Menu Button */}
        <button className="p-2 text-[#5C5C5C] hover:text-[#0F0F0F] transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-105">
          {isMenuOpen ? <X className="h-5 w-5" data-id="element-106" /> : <Menu className="h-5 w-5" data-id="element-107" />}
        </button>
      </div>

      {/* Dropdown Menu */}
      {isMenuOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-white/95 backdrop-blur-md border border-[#E8E6E3] rounded-2xl p-2 shadow-[0_4px_20px_rgba(0,0,0,0.03)] flex flex-col gap-1 animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-108">
          <Link to="/about" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center" onClick={() => setIsMenuOpen(false)} data-id="element-109">
            About
          </Link>
          <Link to="/switch" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center" onClick={() => setIsMenuOpen(false)} data-id="element-110">
            Switch to Andoe
          </Link>
          <Link to="/blog" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center" onClick={() => setIsMenuOpen(false)} data-id="element-111">
            Blog
          </Link>
          <Link to="/contact" className="text-sm font-medium text-[#5C5C5C] hover:text-[#0F0F0F] hover:bg-[#E8E6E3]/30 transition-all duration-200 px-4 py-3 rounded-xl text-center" onClick={() => setIsMenuOpen(false)} data-id="element-112">
            Contact
          </Link>
        </div>}
    </nav>;
}